"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainContent = void 0;
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var pagetype_1 = require("../pagetype");
var stat_1 = require("../../modules/stat");
var web_1 = require("../../config/web");
var huaxiang_stat_1 = require("../../modules/huaxiang_stat");
/**
 * 主要显示区域
 * @returns
 */
function MainContent() {
    var location = (0, react_router_dom_1.useLocation)();
    var hash = location.hash;
    var pathname = location.pathname;
    (0, react_1.useEffect)(function () {
        if (pathname.toLowerCase() == '/center/gridlist.html') {
            (0, huaxiang_stat_1.sendHuaXiangStat_ListIndex)(hash, '1');
        }
        showQQadvertisement(hash, pathname);
        setTimeout(function () {
            (0, stat_1.sendPageID)();
        }, 50);
    }, [hash, pathname]);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(react_router_dom_1.Switch, null,
            react_1.default.createElement(react_router_dom_1.Route, { path: "*", component: pagetype_1.SelectPageType }))));
}
exports.MainContent = MainContent;
/**
 * 顶部期权ifrmae广告展示
 * @param hash
 * @returns
 */
function showQQadvertisement(hash, pathname) {
    var showpages = [
        '#options_sh50etf_',
        '#options_sz50etf_',
        '#options_sahs300etf_',
        '#options_sazz500etf_',
        '#options_kc50etf_',
        '#options_kc50etf1_',
        '#options_kc50etf2_',
        '#options_szetf_',
        '#options_sehs300etf_',
        '#options_sezz500etf_',
        '#options_secybetf_'
    ];
    // if (!/^#options_/.test(hash)) {
    //   $("#qq_adv").hide()
    //   return false
    // }
    if (!!showpages.some(function (v) {
        return (new RegExp("^".concat(v))).test(hash);
    }) || pathname == "".concat(web_1.routerPrefix, "/qqsc.html")) {
        // $("#qq_adv").show()
        if ($('#qq_top_tg').html() == '')
            $('#qq_top_tg').html("<div style=\"margin:0 0 2px;\"><iframe className=\"qqiframe\" width=\"1200\" height=\"60\" frameBorder=\"0\" scrolling=\"no\" marginWidth=\"0\" marginHeight=\"0\" src=\"//same.eastmoney.com/s?z=eastmoney&c=1659&op=1\" ></iframe></div>");
        return false;
    }
    $('#qq_top_tg').html('');
}
